import { render } from "./ServiceCategory.vue?vue&type=template&id=bfe658a6&scoped=true"
import script from "./ServiceCategory.vue?vue&type=script&lang=js"
export * from "./ServiceCategory.vue?vue&type=script&lang=js"

import "./ServiceCategory.vue?vue&type=style&index=0&id=bfe658a6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe658a6"]])

export default __exports__